import React from 'react';

import {
  Text,
  Button,
  Tooltip,
  Counter,
  Box,
} from '@usealloy/component-library';
import { formatPublishedAttributeValue } from '~/entities/published-attributes/utils';
import styled from 'styled-components';

interface PublishedAttribute {
  name: string;
  value: any;
  data_type: string;
  token: string;
}

interface PublishedAttributesCellWithPopoverProps {
  attributes: Array<PublishedAttribute>;
}

const AttributesContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  padding: var(--cl-space-2);
  flex: 1 0 0;
`;

const AttributesHeader = styled(Text)`
  border-bottom: 1px solid var(--cl-gray-400);
  padding: var(--cl-space-2) var(--cl-space-4);
`;

const AttributeItem = styled.li`
  display:flex;
  align-items: center;
  justify-content: space-between;
  padding-right: var(--cl-space-4);
  &:nth-of-type(even) {
    background-color: var(--cl-gray-100);
  }
`;

export const PublishedAttributesCell = ({
  attributes,
}: PublishedAttributesCellWithPopoverProps) => {
  if (!attributes || attributes.length === 0) {
    return <span>—</span>;
  }

  const getAttributesPopoverContent = () => (
    <AttributesContainer justifyContent="flex-start" alignItems="center" style={{ backgroundColor: 'var(--cl-background-default)' }}>
      <section aria-labelledby="published-attributes-list">
        <AttributesHeader weight={700} size={1} id="published-attributes-list">
          Published Attributes
        </AttributesHeader>
      </section>
      <ul>
        {
          attributes.map(attr => (
            <AttributeItem key={attr.token || attr.name} data-testid="published-attribute-item">
              <Box justifyContent="flex-start" gap={2} style={{ padding: 'var(--cl-space-4)' }} width="auto">
                <Text>{attr.name}:</Text>
                <Text>{formatPublishedAttributeValue(attr.value, attr.data_type)}</Text>
              </Box>
            </AttributeItem>
          ))
        }
      </ul>
    </AttributesContainer>
  );

  return (
    <Tooltip
      variant="secondary"
      style={{
        backgroundColor: 'var(--cl-background-default)',
        boxShadow: '0px 2px var(--cl-space-1-5) rgba(0,0,0, 0.08)',
        maxHeight: '50vh',
        overflowY: 'auto',
      }}
      content={getAttributesPopoverContent()}
    >
      <Button
        type="button"
        style={{
          background: 'none',
          border: 'none',
          padding: 0,
        }}
      >
        <Counter count={attributes.length} />
      </Button>
    </Tooltip>
  );
};

